import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import useLenis from "@/lib/useLenis";
import Cursor from "@/components/site/Cursor";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Manifesto from "@/components/site/Manifesto";
import ProjectSlides from "@/components/site/ProjectSlides";
import Studio from "@/components/site/Studio";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import Case from "@/components/site/Case";
import ClientList from "@/components/site/ClientList";

function Home() {
  useLenis();
  const location = useLocation();

  useEffect(() => {
    document.title = "HANKDAVID — Building Worlds for the Discerning";
  }, []);

  // Hash-based scroll: `<Link to="/#contact">` from case-study pages → scroll
  // to that section once Home has mounted. If there is NO hash on navigation
  // to '/', reset scroll to the top (fresh home visit).
  useEffect(() => {
    if (!location.hash) {
      window.scrollTo(0, 0);
      return;
    }
    const id = location.hash.slice(1);
    const scroll = () => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    const t1 = window.setTimeout(scroll, 400);
    const t2 = window.setTimeout(scroll, 1400);
    return () => {
      window.clearTimeout(t1);
      window.clearTimeout(t2);
    };
  }, [location.hash, location.key]);

  return (
    <div className="App grain">
      <Cursor />
      <Navbar />
      <main>
        <Hero />
        <Manifesto />
        <ProjectSlides />
        <Studio />
        <Contact />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#121213",
            color: "#f4f4f5",
            border: "1px solid rgba(255,255,255,0.08)",
            fontFamily: "NB International Pro, sans-serif",
            fontSize: "13px",
            letterSpacing: "0.02em",
            borderRadius: "0px",
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/clients" element={<ClientList />} />
        <Route path="/work/:slug" element={<Case />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
